import { Box, Typography, ListItemText } from "@mui/material";
import React from "react";

export default function PrivacyPolicyPage() {
    return (
        <Box sx={{ maxWidth: 900, mx: "auto", px: 2, py: 4 }}>
            <Typography variant="h4" gutterBottom>
                <title>Privacy Policy | GoodPlaceGeorgia</title>
                <meta
                    name="description"
                    content="Privacy Policy for using the GoodPlaceGeorgia real estate information platform."
                />
            </Typography>
            <Typography variant="h4" gutterBottom>
                Privacy Policy
            </Typography>

            <Typography variant="body1"  component={"p"}>
                This Privacy Policy explains how <strong>goodplaceorgia.com</strong> (“Website”,
                “we”, “us”, or “our”) collects, uses, and protects your personal data.
            </Typography>

            {/* 1 */}
            <Typography variant="h6" gutterBottom>
                1. Who We Are
            </Typography>
            <Typography variant="body1"  component={"p"}>
                goodplaceorgia.com operates an informational real estate platform that provides
                access to property listings, advanced search tools, PDF reports, and listing
                notifications.
            </Typography>
            <Typography variant="body1"  component={"p"}>
                We act as the data controller for personal data collected through the Website.
            </Typography>

            {/* 2 */}
            <Typography variant="h6" gutterBottom>
                2. Information We Collect
            </Typography>

            <Typography variant="subtitle1" gutterBottom>
                &nbsp;2.1 Personal Data You Provide
            </Typography>
            <ul>
                <li><ListItemText primary="Email address (for notifications, account access, or communication)" /></li>
                <li><ListItemText primary="Name or nickname (if provided)" /></li>
                <li><ListItemText primary="Saved search preferences" /></li>
                <li><ListItemText primary="Communication content when you contact us" /></li>
            </ul>

            <Typography variant="subtitle1" gutterBottom>
                &nbsp;2.2 Automatically Collected Data
            </Typography>
            <ul>
                <li><ListItemText primary="IP address" /></li>
                <li><ListItemText primary="Browser type and version" /></li>
                <li><ListItemText primary="Device and operating system information" /></li>
                <li><ListItemText primary="Pages visited and actions performed" /></li>
                <li><ListItemText primary="Approximate location (city or region level)" /></li>
                <li><ListItemText primary="Cookies and similar tracking technologies" /></li>
            </ul>

            {/* 3 */}
            <Typography variant="h6" gutterBottom>
                3. How We Use Your Data
            </Typography>
            <ul>
                <li><ListItemText primary="Provide and improve Website functionality" /></li>
                <li><ListItemText primary="Enable advanced search features and saved searches" /></li>
                <li><ListItemText primary="Generate PDF reports" /></li>
                <li><ListItemText primary="Send notifications about new or matching listings" /></li>
                <li><ListItemText primary="Respond to user inquiries and support requests" /></li>
                <li><ListItemText primary="Monitor usage and prevent misuse or fraud" /></li>
                <li><ListItemText primary="Comply with legal obligations" /></li>
            </ul>

            {/* 4 */}
            <Typography variant="h6" gutterBottom>
                4. Legal Basis for Processing
            </Typography>
            <ul>
                <li><ListItemText primary="Your consent" /></li>
                <li><ListItemText primary="Performance of a contract or service" /></li>
                <li><ListItemText primary="Legitimate interests (Website improvement and security)" /></li>
                <li><ListItemText primary="Legal obligations" /></li>
            </ul>

            {/* 5 */}
            <Typography variant="h6" gutterBottom>
                5. Cookies and Tracking Technologies
            </Typography>
            <Typography variant="body1"  component={"p"}>
                We use cookies and similar technologies to remember preferences, analyze Website
                usage, and improve performance and usability.
            </Typography>
            <Typography variant="body1"  component={"p"}>
                You can control or disable cookies through your browser settings. Some features
                may not function properly without cookies.
            </Typography>

            {/* 6 */}
            <Typography variant="h6" gutterBottom>
                6. Notifications and Marketing Communications
            </Typography>
            <Typography variant="body1"  component={"p"}>
                We send notifications only to users who have opted in. Notifications relate
                solely to real estate listings or Website functionality.
            </Typography>
            <Typography variant="body1"  component={"p"}>
                You can unsubscribe at any time via account settings or notification emails.
                We do not send unsolicited marketing messages.
            </Typography>

            {/* 7 */}
            <Typography variant="h6" gutterBottom>
                7. PDF Reports
            </Typography>
            <Typography variant="body1"  component={"p"}>
                PDF reports are generated based on available listing data and selected filters.
                Temporary storage of parameters may occur but is not used for profiling or
                automated decision-making.
            </Typography>

            {/* 8 */}
            <Typography variant="h6" gutterBottom>
                8. Data Sharing and Third Parties
            </Typography>
            <Typography variant="body1"  component={"p"}>
                We do not sell or rent personal data. Data may be shared only with trusted
                service providers:
            </Typography>
            <ul>
                <li><ListItemText primary="Hosting and infrastructure providers" /></li>
                <li><ListItemText primary="Analytics and performance monitoring services" /></li>
                <li><ListItemText primary="Email or notification service providers" /></li>
            </ul>

            {/* 9 */}
            <Typography variant="h6" gutterBottom>
                9. Data Storage and Security
            </Typography>
            <Typography variant="body1"  component={"p"}>
                Personal data is stored on secure servers with technical and organizational
                safeguards. Access is limited to authorized personnel only.
            </Typography>

            {/* 10 */}
            <Typography variant="h6" gutterBottom>
                10. Data Retention
            </Typography>
            <Typography variant="body1"  component={"p"}>
                We retain personal data only as long as necessary or as required by law.
                You may request deletion of your personal data at any time.
            </Typography>

            {/* 11 */}
            <Typography variant="h6" gutterBottom>
                11. Your Rights
            </Typography>
            <ul>
                <li><ListItemText primary="Access your personal data" /></li>
                <li><ListItemText primary="Correct inaccurate or incomplete data" /></li>
                <li><ListItemText primary="Request deletion of your data" /></li>
                <li><ListItemText primary="Restrict or object to processing" /></li>
                <li><ListItemText primary="Withdraw consent at any time" /></li>
                <li><ListItemText primary="Request data portability" /></li>
            </ul>

            {/* 12 */}
            <Typography variant="h6" gutterBottom>
                12. Children’s Privacy
            </Typography>
            <Typography variant="body1"  component={"p"}>
                The Website is not intended for children under the age of 16.
                We do not knowingly collect personal data from minors.
            </Typography>

            {/* 13 */}
            <Typography variant="h6" gutterBottom>
                13. Changes to This Privacy Policy
            </Typography>
            <Typography variant="body1" component={"p"}>
                We may update this Privacy Policy from time to time. Changes will be published
                on this page with an updated date. Continued use of the Website indicates
                acceptance of the updated Policy.
            </Typography>

            {/* 14 */}
            <Typography variant="h6" gutterBottom>
                14. Contact Information
            </Typography>
            <Typography variant="body1">
                Email: <strong>admin@goodplacegeorgia.com</strong>
            </Typography>
            <Typography variant="body1">
                Website: <strong>https://goodplaceorgia.com</strong>
            </Typography>
        </Box>
    );
}
